import React from "react"
import cx from "classnames"

import { H2, Detail, Link } from "../../elements"

type Props = {
  className?: string
  title: string
  tagline: string
  children: JSX.Element | JSX.Element[]
  label?: string
  to?: string
  align: "left" | "right" | "center"
}

TitledSection.defaultProps = {
  align: "left",
}

function TitledSection({
  className,
  title,
  tagline,
  children,
  label,
  align,
  to,
}: Props) {
  return (
    <section className={cx(className)}>
      <div className="max-w-screen-lg mx-auto px-3 py-16 sm:px-4">
        <H2
          className={cx("text-5xl mb-3 AvenirLTProBlackOblique", "leading-12", {
            "text-center": align == "center",
            "text-left": align == "left",
            "text-right": align == "right",
          })}
        >
          {title}
        </H2>

        <Detail
          className={cx("text-lg mb-6 text-gray-dark font-medium leading-7", {
            "text-center": align == "center",
            "text-left": align == "left",
            "text-right": align == "right",
          })}
        >
          {tagline}
        </Detail>

        {children}

        {!!to && !!label && (
          <div className="mt-16 text-center">
            <Link to={to} type="secondary" className="text-sm inline-block">
              {label}
            </Link>
          </div>
        )}
      </div>
    </section>
  )
}

export default TitledSection
